import { useState } from 'react';

const COCRequestList = ({ cocRequests, onViewRequest }) => {
  const [filterStatus, setFilterStatus] = useState('all');

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'Submitted':
        return 'bg-blue';
      case 'Under Review':
        return 'bg-yellow';
      case 'Approved':
        return 'bg-green';
      case 'Rejected':
        return 'bg-red';
      case 'More Info Required':
        return 'bg-orange';
      default:
        return 'bg-secondary';
    }
  };

  const filteredRequests = filterStatus === 'all'
    ? cocRequests
    : cocRequests.filter(req => req.status === filterStatus);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div>
      {/* Filter Bar */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h3 className="mb-0">COC Request History</h3>
          <div className="text-secondary small mt-1">
            {filteredRequests.length} {filteredRequests.length === 1 ? 'request' : 'requests'}
          </div>
        </div>
        <div>
          <select
            className="form-select"
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
          >
            <option value="all">All Statuses</option>
            <option value="Submitted">Submitted</option>
            <option value="Under Review">Under Review</option>
            <option value="Approved">Approved</option>
            <option value="Rejected">Rejected</option>
            <option value="More Info Required">More Info Required</option>
          </select>
        </div>
      </div>

      {/* COC Requests List */}
      {filteredRequests.length === 0 ? (
        <div className="empty">
          <div className="empty-icon">
            <i className="ti ti-file-alert"></i>
          </div>
          <p className="empty-title">No COC requests found</p>
          <p className="empty-subtitle text-secondary">
            {filterStatus === 'all'
              ? 'No Change of Circumstance requests have been submitted for this loan.'
              : `No requests with status "${filterStatus}".`}
          </p>
        </div>
      ) : (
        <div className="row row-cards">
          {filteredRequests.map(request => (
            <div key={request.id} className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-auto">
                      <span className="avatar avatar-lg">
                        <i className="ti ti-file-text"></i>
                      </span>
                    </div>
                    <div className="col">
                      <div className="d-flex align-items-center mb-2">
                        <h3 className="card-title mb-0 me-3">{request.categoryName}</h3>
                        <span className={`badge ${getStatusBadgeClass(request.status)}`}>
                          {request.status}
                        </span>
                        {request.revisedDisclosureIssued && (
                          <span className="badge bg-teal ms-2">
                            <i className="ti ti-file-check me-1"></i>
                            Revised LE Issued
                          </span>
                        )}
                      </div>
                      <div className="text-secondary mb-2">
                        {request.description.substring(0, 150)}
                        {request.description.length > 150 ? '...' : ''}
                      </div>
                      <div className="row">
                        <div className="col-md-3">
                          <div className="text-secondary small">Submitted</div>
                          <div className="fw-bold">{formatDate(request.submittedDate)}</div>
                        </div>
                        <div className="col-md-3">
                          <div className="text-secondary small">Submitted By</div>
                          <div className="fw-bold">{request.submittedBy}</div>
                        </div>
                        <div className="col-md-3">
                          <div className="text-secondary small">Discovery Date</div>
                          <div className="fw-bold">
                            {new Date(request.discoveryDate).toLocaleDateString('en-US', {
                              year: 'numeric',
                              month: 'short',
                              day: 'numeric'
                            })}
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="text-secondary small">Impacted Elements</div>
                          <div className="fw-bold">{request.impactedElements.length}</div>
                        </div>
                      </div>
                    </div>
                    <div className="col-auto">
                      <button
                        className="btn btn-primary"
                        onClick={() => onViewRequest(request)}
                      >
                        View Details
                      </button>
                    </div>
                  </div>

                  {/* Review Information (if reviewed) */}
                  {request.reviewedBy && (
                    <div className="mt-3 pt-3 border-top">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="text-secondary small">Reviewed By</div>
                          <div className="fw-bold">{request.reviewedBy}</div>
                        </div>
                        <div className="col-md-3">
                          <div className="text-secondary small">Reviewed Date</div>
                          <div className="fw-bold">{formatDate(request.reviewedDate)}</div>
                        </div>
                        <div className="col-md-6">
                          <div className="text-secondary small">Review Notes</div>
                          <div className="fw-bold">{request.reviewNotes || 'No notes provided'}</div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default COCRequestList;
